import { BaseLogging } from '@rx-applications/shared/logging';
import { LogChannelMessageMappings, TemporaryApproverLogEvent } from '../model/log-messages';
import { inject, Injectable } from '@angular/core';

@Injectable()
export class TemporaryApproverLoggerService {
  #loggingService = inject(BaseLogging);

  landedOnOutOfOfficeApproverPage(): void {
    const messageAndChannelMapping = LogChannelMessageMappings[TemporaryApproverLogEvent.LandedOnOutOfOfficeApproverPage];
    this.#loggingService.sendToPubSub(messageAndChannelMapping.channels, messageAndChannelMapping.message);
  }

  approverAdded(): void {
    const messageAndChannelMapping = LogChannelMessageMappings[TemporaryApproverLogEvent.OutOfOfficeApproverAdded];
    this.#loggingService.sendToPubSub(messageAndChannelMapping.channels, messageAndChannelMapping.message);
  }

  approverDeleted(): void {
    const messageAndChannelMapping = LogChannelMessageMappings[TemporaryApproverLogEvent.OutOfOfficeApproverDeleted];
    this.#loggingService.sendToPubSub(messageAndChannelMapping.channels, messageAndChannelMapping.message);
  }
}
